module.exports = __webpack_public_path__ + "static/media/icon_cartao.1f52df98.svg";